import { ROOT_PATH } from 'app/shared/consts';
import { Route, Routes } from 'react-router-dom';

import { AppContentWrapper } from 'app/components/app-content-wrapper/app-content-wrapper';
import { AppRoot } from 'app/components/app-root';
import { DefaultRedirect } from 'app/components/router/default-redirect';
import { ErrorPage } from 'app/pages/error';
import { MiniappMindbodyPage } from 'app/pages/miniapp-mindbody';
import { MiniappSdkDemoPage } from 'app/pages/miniapp-sdk-demo';
import { Private } from 'app/components/router/private';
import React from 'react';

export const AppRouter: React.FC = (): JSX.Element => (
  <AppContentWrapper>
    <Routes>
      <Route path={ROOT_PATH} element={<Private><MiniappMindbodyPage /></Private>} />
      <Route path="/sdk-demo" element={<MiniappSdkDemoPage />} />
      <Route path="/" element={<AppRoot />} />
      <Route path="/error" element={<ErrorPage />} />
      <Route element={<DefaultRedirect />} />
    </Routes>
  </AppContentWrapper>
);
